import { createRouter, createWebHistory } from 'vue-router'
import Home from '../views/Home.vue'
import PoliticaDePrivacidade from '../views/Politica.vue'

const routes = [
  {
    path: '/',
    name: 'Home',
    component: Home
  },
  
  {
    path: '/politica-de-privacidade',
    name: 'PoliticaDePrivacidade',
    component: PoliticaDePrivacidade
  }
]

const router = createRouter({
  history: createWebHistory(process.env.BASE_URL),
  routes
})

export default router
